import React, { Component } from 'react';
import Radium from 'radium';
import BubbleTick from './BubbleTick';

const MAX_TITLE_LENGTH_ALWAYS_ON = 10;

class Bubble extends Component {

	constructor(props) {
		super(props);
		this.state = {
			hovered: false
		};
	}

	getItemCount() {
		var completed = 0;
		var total = 0;

		if (this.props.allTasks) {
			this.props.allTasks.forEach((task) => {
				if (task.id && ((!this.props.bubble && !task.bubble_id) || (this.props.bubble && task.bubble_id && task.bubble_id === this.props.bubble.id) )) {
					total ++;

					if (task.completed) {
						completed ++;
					}
				}
			});
		}

		return {
			completed: completed,
			total: total
		};
	}
	
	getColor1() {
		if (this.props.bubble) {
			return this.props.bubble.color_1
		} else if (this.props.addIcon) {
			return this.props.style.colors.iconGradient.color1;
		}

		return this.props.style.colors.defaultGradient.color1;
	}

	getColor2() {
		if (this.props.bubble) {
			return this.props.bubble.color_2
		} else if (this.props.addIcon) {
			return this.props.style.colors.iconGradient.color2;
		}

		return this.props.style.colors.defaultGradient.color2;
	}

	renderHover() {
		if (!this.state.hovered && !this.props.allOn) {
			return null;
		}

		var title;

		if (this.props.addIcon) {
			title = "Add...";
		} else if (this.props.bubble) {
			if (this.props.allOn) {
				// Trim
				if (this.props.bubble.title.length > MAX_TITLE_LENGTH_ALWAYS_ON) {
					title = this.props.bubble.title.substr(0, MAX_TITLE_LENGTH_ALWAYS_ON) + "...";
				} else {
					title = this.props.bubble.title;
				}
			} else {
				title = this.props.bubble.title;
			}
			
		} else {
			title = "Default";
		}

		return (
			<div style={this.localStyles().hover}>
				<div style={this.localStyles().innerHover}>
					{title}
				</div>
			</div>
		);
	}

	onHover(hovered) {
		this.setState({
			hovered: hovered
		});
	}

	isSelected() {
		if (this.props.allOn) {
			return false;
		}

		if (!this.props.bubble && !this.props.selectedBubble) {
			return true;
		}

		if (this.props.bubble && this.props.selectedBubble && this.props.selectedBubble.id === this.props.bubble.id) {
			return true;
		}

		return false;
	}

	renderAddIcon() {
		return (
			<div style={this.localStyles().plusIcon}>+</div>
		)
	}

	renderCount() {
		if (this.props.addIcon) {
			return this.renderAddIcon();
		}

		const itemCount = this.getItemCount();

		if (itemCount.total === 0) {
			return null;
		}

		var completedCount = itemCount.total - itemCount.completed;

		if (completedCount === 0) {
			return (
				<BubbleTick
					id={this.props.bubble ? this.props.bubble.id : "default"}
					color1={this.getColor1()}
					color2={this.getColor2()}
				/>
			);
		}

		if (completedCount > 3) {
			// This shouldn't happen hopefully!
			return 3;
		}

		return completedCount;

	}
	
	render() {
		var containerStyles = [this.localStyles().container];

		if (!this.props.addIcon && this.isSelected()) {
			containerStyles.push(this.localStyles().containerOn);
		}
		
		return (
			<div style={this.localStyles().outerContainer}>
				<div style={containerStyles} onMouseOver={() => this.onHover(true)} onMouseLeave={() => this.onHover(false)} onClick={this.props.onSelect}>	
					<div style={this.localStyles().innerCircle}>
						{this.renderCount()}
					</div>
					
				</div>
				{this.renderHover()}
			</div>
			
		);
	}

	localStyles() {
		return {
			outerContainer: {
				position: "relative",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				marginLeft: this.props.allOn ? 0 : 10,
				marginRight: this.props.allOn ? 50 : 0,
				userSelect: "none"
			},
			container: {
				backgroundImage: `linear-gradient(0deg, ${this.getColor1()} 0%, ${this.getColor2()} 100%)`,
				width: 24,
				minWidth: 24,
				height: 24,
				borderRadius: 12,
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				userSelect: "none",
				cursor: "pointer",
				transition: "all 0.1s ease-in-out"
			},
			containerOn: {
				transform: "scale3d(1.3,1.3,1.3) translateZ(0)"
			},
			plusIcon: {
				marginTop: -2,
				textAlign: "center"
			},
			innerCircle: {
				width: 18,
				height: 18,
				fontSize: 11,
				fontWeight: "700",
				backgroundColor: this.props.style.colors.white,
				borderRadius: 11,
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			},
			hover: {
				position: "absolute",
				justifyContent: "center",
				display: "flex",
				top: 32,
				left: -50,
				right: -50,
				zIndex: 999
			},
			innerHover: {
				fontSize: 12,
				fontWeight: "700",
				color: this.props.style.colors.white,
				backgroundColor: this.props.style.colors.black,
				paddingLeft: 6,
				paddingRight: 6,
				paddingTop: 2,
				paddingBottom: 2,
				borderRadius: 5,
				animation: 'opacity 0.05s ease-in-out 0s',
				animationName: fadeInKeyframes,
			}
		}
	}
}

const fadeInKeyframes = Radium.keyframes({
	"0%": {opacity: 0, transform: "scale3d(0.2,0.2,0.2)"},
	"100%": {opacity: 1, transform: "scale3d(1,1,1)"}
}, 'fadeIn');

export default Radium(Bubble);


// WEBPACK FOOTER //
// ./src/components/Bubble.js